//const axios = require("axios");

export default class Authentication {

    static expiredRoute = "login"

    static logout() {
        localStorage.clear()
    }

    static getToken() {
        return localStorage.getItem("sysConsultaToken")
    }

    static setToken(valor) {
        return localStorage.setItem("sysConsultaToken", valor)
    }

    static getDataToken(){
        const token = this.getToken()

        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    static tokenExpired() {
        var token = Authentication.getDataToken();

        const expired = Date.now() >= token.exp * 1000
        return expired
    }

      

}